import React from 'react';
import { observer } from 'mobx-react';
import { Button, Icon } from 'semantic-ui-react';

import './ViewClinicDetails.scss';
import placeholder from './placeholder.png';
import ClinicStore from './store';
import dashboard from '../../../stores/dashboard';
import { toJS } from 'mobx';

const avatarPlaceholder =
  'data:image/jpeg;base64,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';

@observer
class ViewClinicDetails extends React.Component {
  getServiceType = () => {
    if (Array.isArray(toJS(ClinicStore.clinicInfo.ClinicServiceTypes)))
      return ClinicStore.clinicInfo.ClinicServiceTypes.reduce((acc, cur) => {
        const service = ClinicStore.clinicServices.find(s => s.Id === cur);
        if (service) acc.push(service.Label);
        return acc;
      }, []).join(', ');
    else return '';
  };

  renderRegisteredSpecialists = () => {
    if (!ClinicStore.registeredSpecialistIds.length) {
      return 'No data';
    }

    return ClinicStore.specialists.slice(0, 8).map(({ Id, Title, FullName, Specialty, Avatar }) => (
      <div className="specialist" key={Id}>
        <div style={{ background: `url(${Avatar || avatarPlaceholder})` }} className="avatar" />
        <div className="specialist-info">
          <h4>
            {FullName} ({Title})
          </h4>
          <span>{Specialty}</span>
        </div>
      </div>
    ));
  };

  getCountryName = id => {
    return ClinicStore.countryList ? ClinicStore.countryList.find(c => c.CountryId === id)?.CountryName : null;
  };

  getStateName = (id, position) => {
    return ClinicStore.cityList[position] ? ClinicStore.cityList[position].find(c => c.CityId === id)?.CityName : null;
  };

  openFormEditClinic = step => {
    localStorage.setItem(`ClinicName`, ClinicStore.clinicInfo.Name);
    dashboard.open(`/view/add-edit-clinic-2?id=${ClinicStore.clinicInfo.ID}&action=edit&step=${step}`);

    this.props.onParamsChange({
      action: 'edit',
      currentStep: step,
    });
  };

  callClinic = phone => {
    if (phone) {
      window.open(`tel:${phone}`);
    } else {
      ClinicStore.toggleModal(true, {
        modalType: 'confirm',
        message: 'Clinic does not have a phone number.',
      })();
    }
  };

  render() {
    return (
      <div className="clinic-details-container">
        <div className="clinic-info">
          <div
            className="clinic-avatar"
            style={{
              background: `url(${ClinicStore.clinicInfo.Avatar || placeholder})`,
            }}
          />
          <div className="clinic-info-details">
            <h1>
              {ClinicStore.clinicInfo.Name} (Centre ID: {ClinicStore.clinicInfo.ID})
            </h1>
            <div className="cta-buttons">
              <Button color="blue" onClick={() => this.callClinic(ClinicStore.clinicInfo.Telephone)}>
                <Icon flipped="horizontally" name="phone" />
                {ClinicStore.clinicInfo.Telephone}
              </Button>
              <Button basic color="blue" onClick={() => this.openFormEditClinic(0)}>
                <Icon name="pencil" />
                Edit
              </Button>
              <button
                className="clinic-calendar"
                onClick={this.handleOpenCalendarTab}
                disabled={!ClinicStore.clinicInfo.ID}
                style={{
                  marginTop: '-15px',
                  marginBottom: '10px',
                  marginLeft: '10px',
                }}
              >
                View this Clinic's calendar
              </button>
            </div>
            <div className="basic-info">
              <div>
                <span>Email:</span>
                <span>{ClinicStore.clinicInfo.Email}</span>
              </div>
              <div>
                <span>Type:</span>
                <span>
                  {ClinicStore.clinicInfo.Type === 'mag' ? 'Medicolegal Provider - Owned Clinic' : 'Non - Owned Clinic'}
                </span>
              </div>
              <div>
                <span>Service Type:</span>
                <span>{this.getServiceType()}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="info-wrapper registered-specialists">
          <div className="title">
            <h3>Registered Specialists</h3>
            <span className="clickable" onClick={() => this.openFormEditClinic(1)}>
              See all
            </span>
          </div>
          <div className="specialist-list">{this.renderRegisteredSpecialists()}</div>
        </div>
        <div className="info-wrapper info-description">
          <div className="title">
            <h3>Description</h3>
          </div>
          <div className="content">{ClinicStore.clinicInfo.Description}</div>
        </div>
        <div className="info-addresses">
          <div className="info-wrapper">
            <div className="title">
              <h3>Office Address</h3>
            </div>
            <div className="basic-info">
              <div>
                <span>Address:</span>
                <span>{ClinicStore.clinicInfo.Address}</span>
              </div>
              <div>
                <span>Suburb:</span>
                <span>{ClinicStore.clinicInfo.District}</span>
              </div>
              <div>
                <span>Postcode:</span>
                <span>{ClinicStore.clinicInfo.Postcode}</span>
              </div>
              <div>
                <span>State:</span>
                <span>{this.getStateName(ClinicStore.clinicInfo.CityId, 0)}</span>
              </div>
              <div>
                <span>Country:</span>
                <span>{this.getCountryName(ClinicStore.clinicInfo.CountryId)}</span>
              </div>
            </div>
          </div>
          <div className="info-wrapper">
            <div className="title">
              <h3>Mailing Address</h3>
            </div>
            <div className="basic-info">
              <div>
                <span>Address:</span>
                <span>{ClinicStore.clinicInfo.CorrespondenceAddress}</span>
              </div>
              <div>
                <span>Suburb:</span>
                <span>{ClinicStore.clinicInfo.CorrespondenceDistrict}</span>
              </div>
              <div>
                <span>Postcode:</span>
                <span>{ClinicStore.clinicInfo.CorrespondencePostcode}</span>
              </div>
              <div>
                <span>State:</span>
                <span>{this.getStateName(ClinicStore.clinicInfo.CorrespondenceCityId, 1)}</span>
              </div>
              <div>
                <span>Country:</span>
                <span>{this.getCountryName(ClinicStore.clinicInfo.CorrespondenceCountryId)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ViewClinicDetails;
